import {NgModule, Component} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ListPageComponent} from './list-page/list-page.component';
import {UserListComponent} from './user-list/user-list.component';
import {CreatePageComponent} from './create-page/create-page.component';
import {EditpagesComponent} from './editpages/editpages.component';
import {OurchannelComponent} from './ourchannel/ourchannel.component';
import {ChannelmessageComponent} from './channelmessage/channelmessage.component';
import {ScrappedUserListComponent} from './scrapped-user-list/scrapped-user-list.component';
import {ChannelAddUserHistoryListComponent} from './channel-add-user-history-list/channel-add-user-history-list.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'list-page',
                component: ListPageComponent,
                data: {
                    title: 'List Page',
                    breadcrumb: 'List Page'
                }
            },
            {
                path: 'user-list',
                component: UserListComponent,
                data: {
                    title: 'Users List Page',
                    breadcrumb: 'Users List Page'
                }
            },
            {
                path: 'create-page',
                component: CreatePageComponent,
                data: {
                    title: 'Create Page',
                    breadcrumb: 'Create Page'
                }
            }
            ,
            {
                path: 'create-page/:id',
                component: CreatePageComponent,
                data: {
                    title: 'Create Page',
                    breadcrumb: 'Create Page'
                }
            }, {
                path: 'edit-page/:id',
                component: EditpagesComponent,
                data: {
                    title: 'Edit Page',
                    breadcrumb: 'Edit Page'
                }
            }, {
                path: 'our-channel',
                component: OurchannelComponent,
                data: {
                    title: 'Our Channel Page',
                    breadcrumb: 'Our Channel Page'
                }
            }, {
                path: 'channel-message',
                component: ChannelmessageComponent,
                data: {
                    title: 'Channel Message',
                    breadcrumb: 'Channel Message'
                }
            }
            , {
                path: 'scrapped-users',
                component: ScrappedUserListComponent,
                data: {
                    title: 'Scrapper Users',
                    breadcrumb: 'Scrapper Users'
                }
            }
            , {
                path: 'add-user-to-channel-history',
                component: ChannelAddUserHistoryListComponent,
                data: {
                    title: 'Add User To Channel History',
                    breadcrumb: 'Add User To Channel History'
                }
            }



        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TelegramRoutingModule {
}
